import MuiHelpIcon from '@mui/icons-material/Help'
import { IconProps } from './iconBase'

/** ヘルプ表示を示すアイコン */
export const HelpIcon = (props: IconProps) => {
  return <MuiHelpIcon {...props} />
}
